/* 무료보험 프로모션 추가부분 */
import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'

import style from './MyhouseInsuranceGuide.module.scss'

import SvgCertificationTitleClose from '@Ui/images/myhouse/myhouse_main_certification--close.svg'
import { AUTH_STATUS } from '@Root/contants'
import useMain from '@Hooks/myhouse/main/useMain'
import { MY_HOUSE_AUTH_METHOD } from '@Root/contants/myhouse'
import usePromotion from '@Hooks/myhouse/usePromotion'

const cx = className.bind(style)

type Props = {
  text: string
  houseNo?: number
  ownerAuthStatus?: AUTH_STATUS
  authMethod?: string
}

const MyhouseInsuranceGuide = ({ text, houseNo, ownerAuthStatus, authMethod }: Props) => {
  const { refreshMasonryGrid } = useMain()
  const [isClose, setIsClose] = useState(true)
  const promotionFailGuideState = `${houseNo}_promotionFailGuide`
  const isAlreadyVisitedAfterReject = ownerAuthStatus === AUTH_STATUS.REJECT && localStorage.getItem(promotionFailGuideState) === 'reject'
  const isAlreadyVisitedAfterFail = ownerAuthStatus === AUTH_STATUS.FAIL && localStorage.getItem(promotionFailGuideState) === 'fail'
  const { promotion, loadIsPromotionCanceled } = usePromotion()
  const { isPromotionCanceled } = promotion

  const handlePromotionGuideClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setIsClose(true)
    refreshMasonryGrid()
  }

  useEffect(() => {
    if (authMethod !== MY_HOUSE_AUTH_METHOD.CERTIFICATE_OF_REALESTATE_REGISTER || (ownerAuthStatus !== AUTH_STATUS.REJECT && ownerAuthStatus !== AUTH_STATUS.FAIL)) {
      setIsClose(true)
      return
    }

    if (isAlreadyVisitedAfterReject || isAlreadyVisitedAfterFail || !houseNo) {
      setIsClose(true)
      return
    }

    if (ownerAuthStatus === AUTH_STATUS.REJECT) {
      localStorage.setItem(promotionFailGuideState, 'reject')
    } else {
      localStorage.setItem(promotionFailGuideState, 'fail')
    }
    setIsClose(false)
    loadIsPromotionCanceled(houseNo)
  }, [houseNo])

  if (isClose || !isPromotionCanceled) {
    return null
  }

  return (
    <div className={cx('article')}>
      <div className={cx('content')}>
        <p className={cx('text')}>{text}</p>
        <button className={cx('button')} onClick={handlePromotionGuideClose}>
          <SvgCertificationTitleClose />
          <span className="blind">닫기</span>
        </button>
      </div>
    </div>
  )
}

export default MyhouseInsuranceGuide
